<!--我的咨询-->
<template>
    <div class="my-consultation">
        <div class="module-name">
            <div class="module-title">我的咨询</div>
        </div>
        <v-table
            :columns="columns"
            :tableData="tableData"
            v-model="selectItems"
            :isShowLoading="isShowLoading"
            :isShowNoData="isShowNoData"
        ></v-table>
        <pagination :current="page.current" :total="page.total" @on-change="changePage"></pagination>
        <publicModal
            ref="questionModal"
            name="questionModal"
            width="80%"
            :title="'咨询回复详情'"
            @beforeOpen="beforeOpen"
            @confirm="confirm"
            @closed="closed"
            onlyLook="true"
        >
            <div class="question-info">
                <div class="row">
                    <div class="col-lg-2 textleft">标题：</div>
                    <div class="col-lg-8" v-text="questionInfo.title"></div>
                    <div class="col-lg-2" v-if="questionInfo.filePath">
                        <a
                            type="button"
                            class="btn btn-default btn-sm"
                            :href="'/interqa/answer/downloadFile?filePath='+questionInfo.filePath"
                            download
                        >附件下载</a>
                        <!-- <button type="button" class="btn btn-default" @click="filedownLoad(questionInfo.filePath)"> 附件下载</button> -->
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-2 textleft">正文：</div>
                    <div class="col-lg-9" v-text="questionInfo.content"></div>
                </div>
                <div class="row">
                    <div class="col-lg-2 textleft">顾问回复：</div>
                    <div class="col-lg-9" v-if="answerInfo.length>0">
                        <div
                            class="row"
                            v-for="(answer,index) in answerInfo"
                            :key="index"
                            style="border-bottom:1px #f5f5f5 solid;padding-bottom:10px;"
                        >
                            <div class="col-lg-2" style="color:#337ab7;">
                                <div v-text="answer.username+'：'"></div>
                                <div class="time" v-text="answer.repateTimeStr"></div>
                            </div>
                            <div class="col-lg-8" v-text="answer.content"></div>
                        </div>
                    </div>
                    <div class="col-lg-9" v-if="answerInfo.length==0" style="color:red">暂无回复</div>
                </div>
            </div>
        </publicModal>
    </div>
</template>
<script>
export default {
    name: "myConsultation",
    data() {
        return {
            tableData: [],
            selectItems: [],
            isShowLoading: false,
            isShowNoData: false,
            questionInfo: {},
            answerInfo: [],
            page: {
                current: 1,
                total: 0,
                pagesize: 10
            },
            columns: [
                {
                    type: "number",
                    title: "序号",
                    width: 50
                },
                {
                    field: "num",
                    title: "咨询编号",
                    width: 80
                },
                {
                    field: "title",
                    title: "标题",
                    width: 200
                },{
                    field: "isanswer",
                    title: "是否有回复",
                    width: 200,
                    dataFormatter(data){
                        return data.isanswer==1?'没有回复':'有回复'
                    }
                },
                {
                    field: "createTimeStr",
                    title: "创建时间",
                    width: 140
                },
                {
                    field: "oper",
                    title: "操作",
                    width: 200,
                    render: (h, params) => {
                        return h("div", [
                            // h(
                            //     "button",
                            //     {
                            //         class: "btn btn-primary",
                            //         domProps: {
                            //             innerText: "更新"
                            //         },
                            //         on: {
                            //             click: () => {}
                            //         }
                            //     },
                            //     ""
                            // ),
                            h(
                                "button",
                                {
                                    class: "btn btn-danger btn-sm",
                                    domProps: {
                                        innerText: "删除"
                                    },
                                    on: {
                                        click: row => {
                                            this.delete(params.row.id);
                                        }
                                    }
                                },
                                ""
                            ),
                            h(
                                "button",
                                {
                                    class: "btn btn-primary btn-sm",
                                    domProps: {
                                        innerText: "查看回复"
                                    },
                                    on: {
                                        click: row => {
                                            this.$refs.questionModal.show(
                                                params.row.id
                                            ); //打开咨询详情的弹窗
                                        }
                                    }
                                },
                                ""
                            )
                        ]);
                    }
                }
            ]
        };
    },
    mounted() {
        this.requestData();
    },
    methods: {
        requestData() {
            this.$http
                .post("/question/queryMyQuestion", {
                    pageNo: this.page.current,
                    pageSize: this.page.pagesize
                })
                .then(res => {
                    if (res) {
                        this.tableData = res.result;
                        this.isShowLoading = false;
                        if (res.result.length == 0) {
                            this.isShowNoData = true;
                        } else {
                            this.isShowNoData = false;
                            this.page.current = res.thisPageNumber;
                            this.page.total = res.totalCount;
                            this.page.pagesize = res.pageSize;
                        }
                    }
                });
        },
        changePage(pageNum) {
            this.page.current = pageNum;
            this.requestData();
        },
        delete(questionId) {
            this.$confirm.init({
                title: "删除咨询",
                content: "确认删除该咨询吗？",
                onOk: () => {
                    this.$http
                        .post("/question/deleteQuestion", {
                            questionId: questionId
                        })
                        .then(res => {
                            if (res) {
                                this.$alert.init({
                                    type: "success",
                                    content: res.content
                                });
                                this.requestData();
                            }
                        });
                }
            });
        },
        beforeOpen(qid) {
            this.findQuestionById(qid).then(() => {
                this.queryAnswersByQuestionId();
            });
        },
        confirm() {},
        closed() {},
        findQuestionById(qid) {
            return this.$http
                .post("/question/findQuestionById", {
                    id: qid
                })
                .then(res => {
                    if (res) {
                        this.questionInfo = res;
                    }
                });
        },
        //根据咨询id 获取回复的详情
        queryAnswersByQuestionId() {
            this.$http
                .post("/answer/queryAnswersByQuestionId", {
                    pageNo: 1,
                    pagesize: 1000,
                    questionid: this.questionInfo.id
                })
                .then(res => {
                    if (res) {
                        this.answerInfo = res.result;
                    }
                });
        }
    }
};
</script>
<style lang="less" scoped>
.my-consultation {
    .row {
        margin-bottom: 10px;
    }
    .question-info {
        height: 450px;
        overflow-y: auto;
        overflow-x: hidden;
    }
    .textleft {
        text-align: right;
    }
    .time {
        font-size: 12px;
    }
}
</style>